import { useEffect } from "react";
import {
  SITE_URL,
  buildShopJsonLd,
  describeShop,
  shopTitle,
} from "./shopSeo";

const SCRIPT_ID = "shop-structured-data";

const setMetaContent = (selector, value) => {
  const element = document.head.querySelector(selector);
  if (element) element.setAttribute("content", value);
};

/**
 * Once the real shop data has loaded, replaces the URL-based title/description
 * that SeoUpdater set with the shop's actual details, points the canonical URL
 * at the shop's proper address, and adds LocalBusiness structured data.
 *
 * @param publicShop shop object from GET /api/main/shop/:id (see usePublicShop)
 */
const useShopSeo = (publicShop) => {
  useEffect(() => {
    if (!publicShop?.shop_name) return undefined;

    const url = `${SITE_URL}${publicShop.path}`;
    const title = shopTitle(publicShop);
    const description = describeShop(publicShop);

    document.title = title;
    setMetaContent('meta[name="description"]', description);
    setMetaContent('meta[property="og:title"]', title);
    setMetaContent('meta[property="og:description"]', description);
    setMetaContent('meta[property="og:url"]', url);
    setMetaContent('meta[name="twitter:title"]', title);
    setMetaContent('meta[name="twitter:description"]', description);
    document.head
      .querySelector('link[rel="canonical"]')
      ?.setAttribute("href", url);

    // Replaces the server-rendered copy too, since it uses the same id
    document.getElementById(SCRIPT_ID)?.remove();
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = SCRIPT_ID;
    script.text = JSON.stringify(buildShopJsonLd(publicShop, url));
    document.head.appendChild(script);

    return () => script.remove();
  }, [publicShop]);
};

export default useShopSeo;
